<template>
  <div>
    <v-card :loading="isLoading" class="mb-2">
      <v-card-title>
        <v-icon>mdi-gesture-tap-box</v-icon>
        Denetim Raporu
      </v-card-title>
      <v-card-subtitle>
        {{ $t("helper_text.reports.review") }}
      </v-card-subtitle>

      <v-card-text v-if="clusterId">
        <v-form @submit.prevent="handleFormSubmit()" ref="form">
          <v-row dense>
            <v-col sm="4">
              <rs-datepicker
                label="Başlangıç Tarihi"
                v-model="formData.date.min"
                :rules="[rules.maxDate(formData.date.min, formData.date.max)]"
                required
              />
            </v-col>

            <v-col sm="4">
              <rs-datepicker
                label="Bitiş Tarihi"
                v-model="formData.date.max"
                :rules="[rules.minDate(formData.date.max, formData.date.min)]"
                required
              />
            </v-col>

            <v-col sm="4">
              <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                color="primary"
                type="submit"
                class="ms-3"
              >
                Göster
              </v-btn>

              <ReportDownloadButton
                @download="handleDownloadClick"
                :types="['odt', 'docx', 'ods', 'xlsx', 'pdf']"
              />
            </v-col>
          </v-row>
        </v-form>

        <p v-if="iframeUrl" class="mt-3 mb-0 text-h5">
          <a :href="iframeUrl" download="rapor.pdf" target="_blank">
            Raporu cihazınıza indirmek için tıklayın.
          </a>
        </p>

        <iframe
          class="mt-3"
          :src="iframeUrl"
          frameborder="0"
          v-if="iframeUrl"
          style="width: 100%; height: 140vh"
        ></iframe>
      </v-card-text>

      <v-card-text v-else>
        Raporu görebilmek için üst menüden toplu yaşam alanı seçin.
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { hasForm } from "@/view/mixins";
import ReportDownloadButton from "./ReportDownloadButton.vue";
import { slugify } from "@/core/helpers";

export default {
  mixins: [hasForm],
  components: { ReportDownloadButton },
  computed: {
    ...mapGetters(["cluster", "clusterId"]),
  },
  data() {
    const date = new Date();
    const min = new Date(
      Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1)
    );
    const max = new Date(
      Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
    );

    return {
      iframeUrl: null,
      reportData: null,
      consistent: true,
      formData: {
        date: {
          min: min.toJSON().split("T")[0],
          max: max.toJSON().split("T")[0],
        },
      },
    };
  },
  methods: {
    handleFormSubmit(format) {
      let download = true;
      if (!format) {
        download = false;
        format = "pdf";
      }

      if (this.isLoading || !this.$refs.form.validate() || !this.clusterId) {
        this.$toast.error("Lütfen tüm gerekli alanları doldurunuz");
        return false;
      }

      const params = {
        usage_type_id: "download",
        file_type: "pdf",
        paper_size: "A4",
        date: this.formData.date,
      };

      this.isLoading = true;

      return this.$api
        .query(`reports/review/${this.clusterId}`, { params })
        .then((response) => {
          this.reportData = Object.assign({}, response.data.data);
          for (const index in this.formData) {
            if (response.data.data[index] !== undefined) {
              this.reportData[index] = response.data.data[index];
            }
          }
          this.reportData.start_date = new Date(
            this.formData.date.min
          ).toLocaleDateString();
          this.reportData.end_date = new Date(
            this.formData.date.max
          ).toLocaleDateString();

          if (format !== "xlsx" && format !== "ods") {
            for (const index in this.reportData.past_periods) {
              const item = this.reportData.past_periods[index];

              item.amount = this.numberToLocaleFormat(item.amount);
            }
            for (const index in this.reportData.current_periods) {
              const item = this.reportData.current_periods[index];

              item.amount = this.numberToLocaleFormat(item.amount);
            }
            for (const index in this.reportData.expenses) {
              const item = this.reportData.expenses[index];

              item.transfer_amount = this.numberToLocaleFormat(
                item.transfer_amount
              );
              item.amount = this.numberToLocaleFormat(item.amount);
              item.collecting = this.numberToLocaleFormat(item.collecting);
              item.remaining = this.numberToLocaleFormat(item.remaining);
              item.total_remaining = this.numberToLocaleFormat(
                item.total_remaining
              );
            }
            for (const index in this.reportData.incomes) {
              const item = this.reportData.incomes[index];

              item.transfer_amount = this.numberToLocaleFormat(
                item.transfer_amount
              );
              item.transfer_amount_main = this.numberToLocaleFormat(
                item.transfer_amount_main
              );
              item.transfer_amount_deferment = this.numberToLocaleFormat(
                item.transfer_amount_deferment
              );
              item.amount = this.numberToLocaleFormat(item.amount);
              item.amount_main = this.numberToLocaleFormat(item.amount_main);
              item.amount_deferment = this.numberToLocaleFormat(
                item.amount_deferment
              );
              item.collecting = this.numberToLocaleFormat(item.collecting);
              item.collecting_returned = this.numberToLocaleFormat(
                item.collecting_returned
              );
              item.remaining = this.numberToLocaleFormat(item.remaining);
              item.total_remaining = this.numberToLocaleFormat(
                item.total_remaining
              );
            }

            this.reportData.total_sums.past_period_sums =
              this.numberToLocaleFormat(
                this.reportData.total_sums.past_period_sums
              );
            this.reportData.total_sums.current_period_sums =
              this.numberToLocaleFormat(
                this.reportData.total_sums.current_period_sums
              );

            this.reportData.total_sums.expense_sums.transfer_amount =
              this.numberToLocaleFormat(
                this.reportData.total_sums.expense_sums.transfer_amount
              );
            this.reportData.total_sums.expense_sums.amount =
              this.numberToLocaleFormat(
                this.reportData.total_sums.expense_sums.amount
              );
            this.reportData.total_sums.expense_sums.collecting =
              this.numberToLocaleFormat(
                this.reportData.total_sums.expense_sums.collecting
              );
            this.reportData.total_sums.expense_sums.remaining =
              this.numberToLocaleFormat(
                this.reportData.total_sums.expense_sums.remaining
              );
            this.reportData.total_sums.expense_sums.total_remaining =
              this.numberToLocaleFormat(
                this.reportData.total_sums.expense_sums.total_remaining
              );

            this.reportData.total_sums.income_sums.transfer_amount =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.transfer_amount
              );
            this.reportData.total_sums.income_sums.transfer_amount_main =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.transfer_amount_main
              );
            this.reportData.total_sums.income_sums.transfer_amount_deferment =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.transfer_amount_deferment
              );
            this.reportData.total_sums.income_sums.amount =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.amount
              );
            this.reportData.total_sums.income_sums.amount_main =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.amount_main
              );
            this.reportData.total_sums.income_sums.amount_deferment =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.amount_deferment
              );
            this.reportData.total_sums.income_sums.collecting =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.collecting
              );
            this.reportData.total_sums.income_sums.collecting_returned =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.collecting_returned
              );
            this.reportData.total_sums.income_sums.remaining =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.remaining
              );
            this.reportData.total_sums.income_sums.total_remaining =
              this.numberToLocaleFormat(
                this.reportData.total_sums.income_sums.total_remaining
              );
          }

          return this.reportData;
        })
        .then(() => {
          let fileName = this.cluster.name + "-";
          fileName += new Date(this.formData.date.min).toLocaleDateString();
          fileName += "-";
          fileName += new Date(this.formData.date.max).toLocaleDateString();
          fileName += "-";
          fileName += "-DenetimRaporu";

          if (fileName.length >= 100) {
            fileName = fileName.substring(0, 99);
          }

          const params = {
            file_type: format,
            print_template: "ReviewReport",
            receiptData: this.reportData,
            file_name: slugify(fileName),
          };

          params.paper_size = "A4";
          params.copies = 1;

          return this.$api.post("print-file", params).then((response) => {
            if (download) {
              const anchor = document.createElement("a");
              anchor.href = response.data.data.url;
              anchor.target = "_blank";
              anchor.click();
            } else {
              this.iframeUrl = response.data.data.url;
            }
          });
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    handleDownloadClick(format) {
      this.handleFormSubmit(format || "pdf", true);
    },
  },
};
</script>
